module.exports = __webpack_public_path__ + "img/indian-river-logo.15156cfd.jpg";